import { getAvailableRegions, getCurrentRegion, redirectToRegion } from "../utils/regions";
import i18n from "i18next";
import * as React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";
export const RegionSelector = () => {
    const currentRegion = getCurrentRegion();
    const availableRegions = getAvailableRegions();
    const options = availableRegions.map(region => ({
        key: region.code,
        text: `${region.flag} ${region.name}`,
        value: region.code,
    }));
    function handleChange(_, data) {
        const newRegion = data.value;
        redirectToRegion(newRegion);
    }
    return (React.createElement(Form.Field, { style: { display: "flex", alignItems: "center", gap: 4 } },
        React.createElement(Label, { size: "small", style: {
                padding: "0 12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "#fff",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                height: "stretch",
                display: "flex",
                alignItems: "center",
            } }, i18n.t("login.region")),
        React.createElement(Dropdown, { fluid: true, selection: true, options: options, disabled: availableRegions.length <= 1, defaultValue: currentRegion, onChange: handleChange })));
};
